import React, { useEffect, useState } from "react";
// import CrossIcon from "../../../../assets/icons/cross-icon.svg";

interface EventMarketButtonProps {
  mainValue?: any;
  mainValueClass?: "price" | "runs";
  subValue?: number | null;
  subValueClass?: "size" | "odds";
  disable?: boolean;
  oddType:
    | "back-odd"
    | "lay-odd"
    | "odds-yes-cell"
    | "odds-no-cell"
    | "premium-odd";
  valueType?:
    | "matchOdds"
    | "bookmakerOdds"
    | "fancyMarketOdds"
    | "binaryOdds"
    | "premiumOdds";
  onClick?: () => void;
  oddsSet?: number[] | null;
  showSubValueinKformat?: boolean;
  customBgColor?: string;
  hideVolume?: boolean;
}

const EventMarketButton: React.FC<EventMarketButtonProps> = (props) => {
  const {
    mainValue,
    // mainValueClass,
    subValue,
    // subValueClass,
    disable,
    oddType,
    valueType,
    onClick,
    oddsSet,
    customBgColor,
    showSubValueinKformat,
    hideVolume,
  } = props;
  const [currentValue, setCurrentValue] = useState<number | null>(null);
  const [classes, setClasses] = useState<string>("exch-odd-button");
  const [timer, setTimer] = useState<number | null>(null);
  const [currentOdds, setCurrentOdds] = useState<number[]>([]);
  const [volume, setVolume] = useState<number>();
  const subValprecision: number = valueType === "matchOdds" ? 0 : 0;

  useEffect(() => {
    if (subValue) {
      if (valueType === "matchOdds") setVolume(subValue * 1000);
      else setVolume(subValue);
    }
  }, [subValue, valueType]);

  const oddValueChanged = () => {
    if (timer) {
      clearTimeout(timer);
    }

    const chVal = mainValue;
    if (chVal) {
      const cVal = currentValue;
      setCurrentValue(chVal);
      let showAnimation = true;
      if (oddsSet && oddsSet.length > 0) {
        showAnimation = !currentOdds.includes(chVal);
        setCurrentOdds(oddsSet);
      }
      if (showAnimation) {
        if (cVal && chVal !== cVal) {
          if (!classes.includes("odd-change"))
            setClasses(classes + " odd-change");
          setTimer(
            setTimeout(
              () => setClasses(classes.replace(" odd-change", "")),
              5000
            ) as unknown as number
          );
        }
      }
    }
  };

  useEffect(() => {
    oddValueChanged();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mainValue, subValue]);

  const pinkOrBlueColor = oddType === "lay-odd" ? "bg-pink1" : "bg-blue13";
    const disabledBgColor =
    oddType === "lay-odd" || oddType === "odds-no-cell"
      ? "bg-pink1 opacity-50"
      : "bg-blue13 opacity-50";

  return (
    <>
      {mainValue && Number(mainValue) > 0 ? (
        <div
          className={`w-full h-full ${
            disable ? disabledBgColor : ""
          } ${classes} cursor-pointer flex justify-center items-center  
              text-white ${customBgColor || pinkOrBlueColor}`}
          onClick={() => (!disable ? onClick?.() : {})}
        >
          <div
            className={`flex flex-col justify-center items-center gap-1 ${
              oddType === "premium-odd" ? "h-full" : ""
            } `}
          >
            <div className={`text-[11px] text-black font-[700]`}>
              {Number.isNaN(Number(mainValue)) ? (
                <br></br>
              ) : valueType === "fancyMarketOdds" ? (
                Number(mainValue)
              ) : (
                Number(mainValue).toFixed(2)
              )}
            </div>

            {oddType !== "premium-odd" &&
            valueType !== "bookmakerOdds" &&
            !hideVolume ? (
              <div className="text-[10px] text-[#292929] leading-none ">
                {volume
                  ? showSubValueinKformat && Number(volume > 999)
                    ? Number(volume / 1000).toFixed(subValprecision) + "K"
                    : Number(volume).toFixed(subValprecision)
                  : "0.00K"}
              </div>
            ) : null}
          </div>
        </div>
      ) : (
        <div
          className={`w-full h-full flex justify-center items-center disabled ${
            customBgColor || pinkOrBlueColor
          } ${classes}`}
        >
          -
        </div>
      )}
    </>
  );
};
export default EventMarketButton;
